import { useEffect, useRef } from 'react';
import { Subject } from 'rxjs';

export const useSubject = (subscription, deps, ...pipe) => {

    const subject$ = useRef(new Subject());
    if (!deps) {
        deps = [];
    }
    if (!Array.isArray(deps)) {
        pipe.unshift(deps);
        deps = [];
    }

    useEffect(() => {
        const eventSubscription = subject$.current.pipe(...pipe).subscribe(subscription);

        return () => {
            eventSubscription.unsubscribe();
        };
    }, deps);

    return subject$.current;
};
